import React from 'react'

import { IconFCType } from '@ui/icons/types'
import { createValidIcon } from '@ui/icons/utils/type-helper'

const BitcoinCurrencyIcon = createValidIcon(({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 12C0 18.6273 5.37267 24 12 24C18.6273 24 24 18.6273 24 12C24 5.37267 18.6273 0 12 0C5.37267 0 0 5.37267 0 12Z'
      fill='#F7931A'
    />
    <path
      d='M16.3067 10.6935C16.5147 9.29283 15.4567 8.54016 14.0087 8.03683L14.478 6.1395L13.3314 5.85083L12.874 7.69883C12.5685 7.62336 12.2623 7.55091 11.9554 7.4815L12.4154 5.6215L11.2694 5.3335L10.8 7.23016C10.5552 7.17521 10.311 7.11765 10.0674 7.0575L10.0687 7.05083L8.48737 6.6535L8.18271 7.88683C8.18271 7.88683 9.03337 8.08416 9.01537 8.09616C9.48004 8.21283 9.56337 8.52283 9.55004 8.76816L9.01404 10.9302C9.04671 10.9382 9.08804 10.9502 9.13404 10.9682L9.01271 10.9382L8.26271 13.9668C8.20604 14.1088 8.06137 14.3222 7.73737 14.2408C7.74871 14.2582 6.90404 14.0322 6.90404 14.0322L6.33337 15.3535L7.82604 15.7282C8.10337 15.7982 8.37537 15.8715 8.64337 15.9408L8.16871 17.8608L9.31471 18.1482L9.78471 16.2488C10.088 16.3322 10.3927 16.4115 10.698 16.4882L10.23 18.3782L11.3767 18.6662L11.8514 16.7502C13.8067 17.1235 15.278 16.9722 15.8967 15.1902C16.3954 13.7568 15.872 12.9288 14.8434 12.3888C15.592 12.2155 16.1567 11.7188 16.3074 10.6928L16.3067 10.6935ZM13.6867 14.3948C13.3327 15.8295 10.9347 15.0542 10.1574 14.8595L10.7867 12.3162C11.564 12.5115 14.0574 12.8988 13.6867 14.3948ZM14.042 10.6728C13.7187 11.9782 11.722 11.3148 11.0754 11.1528L11.646 8.84616C12.2934 9.00883 14.3794 9.31216 14.042 10.6728Z'
      fill='white'
    />
  </svg>
))

const EthereumCurrencyIcon = createValidIcon(({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 12C0 18.6273 5.37267 24 12 24C18.6273 24 24 18.6273 24 12C24 5.37267 18.6273 0 12 0C5.37267 0 0 5.37267 0 12Z'
      fill='#627EEA'
    />
    <path d='M12 4.6665V10.0878L16.6647 12.1358L12 4.6665Z' fill='white' fillOpacity='0.602' />
    <path d='M11.9987 4.6665L7.33337 12.1358L11.9987 10.0892V4.6665Z' fill='white' />
    <path d='M12 15.6493V19.3333L16.668 12.9893L12 15.6493Z' fill='white' fillOpacity='0.602' />
    <path d='M11.9987 19.3331V15.6491L7.33337 12.9878L11.9987 19.3331Z' fill='white' />
    <path d='M12 14.7978L16.6647 12.1365L12 10.0898V14.7978Z' fill='white' fillOpacity='0.2' />
    <path
      d='M7.33337 12.1358L11.9987 14.7972V10.0898L7.33337 12.1352V12.1358Z'
      fill='white'
      fillOpacity='0.602'
    />
  </svg>
))

const TetherCurrencyIcon = createValidIcon(({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
      fill='#1BA27A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.26038 7.20068V9.51402H10.945V12.9147H13.2904V9.51468H16.975V7.20068H7.26038Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9933 12.5978C17.9933 11.8645 15.3347 11.2705 12.056 11.2705C8.778 11.2705 6.12 11.8645 6.12 12.5978C6.12 13.2438 8.18133 13.7812 10.912 13.9005V18.6285H13.1587V13.9025C15.9107 13.7872 17.9933 13.2472 17.9933 12.5978ZM12.0567 13.4558C9.13666 13.4558 6.77 12.9952 6.77 12.4265C6.76933 11.8572 9.136 11.3972 12.056 11.3972C14.976 11.3972 17.3427 11.8572 17.3427 12.4265C17.3427 12.9952 14.9767 13.4558 12.0567 13.4558Z'
      fill='white'
    />
  </svg>
))

const UsdCoinCurrencyIcon = createValidIcon(({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24Z'
      fill='#2775CA'
    />
    <path
      d='M15.3001 13.9001C15.3001 12.1501 14.2501 11.5501 12.1501 11.3002C10.6501 11.1001 10.3501 10.7002 10.3501 10.0001C10.3501 9.30002 10.8501 8.85014 11.8501 8.85014C12.7501 8.85014 13.2501 9.15014 13.5001 9.90014C13.5501 10.0501 13.7001 10.1501 13.8501 10.1501H14.65C14.8501 10.1501 15.0001 10.0001 15.0001 9.80018V9.75014C14.8 8.6501 13.9 7.80014 12.7501 7.70018V6.50018C12.7501 6.30014 12.6001 6.15014 12.3501 6.1001H11.6001C11.4001 6.1001 11.2501 6.2501 11.2 6.50018V7.65014C9.70002 7.85018 8.7501 8.85014 8.7501 10.1002C8.7501 11.7502 9.75006 12.4001 11.8501 12.6502C13.2501 12.9001 13.7001 13.2001 13.7001 14.0002C13.7001 14.8002 13 15.3502 12.0501 15.3502C10.75 15.3502 10.3 14.8001 10.15 14.0501C10.1001 13.8502 9.9501 13.7501 9.8001 13.7501H8.95002C8.7501 13.7501 8.6001 13.9001 8.6001 14.1001V14.1502C8.80002 15.4001 9.60006 16.3001 11.2501 16.5502V17.7502C11.2501 17.9501 11.4001 18.1001 11.65 18.1501H12.4C12.6001 18.1501 12.7501 18.0001 12.8001 17.7502V16.5502C14.3001 16.3001 15.3001 15.2501 15.3001 13.9001Z'
      fill='white'
    />
    <path
      d='M9.45 19.1499C5.55 17.75 3.54996 13.4 5.00004 9.54992C5.75004 7.44992 7.40004 5.84996 9.45 5.09996C9.65004 5 9.75 4.85 9.75 4.59992V3.89996C9.75 3.69992 9.65004 3.54992 9.45 3.5C9.39996 3.5 9.3 3.5 9.24996 3.54992C4.5 5.04992 1.89996 10.1 3.39996 14.85C4.29996 17.6499 6.45 19.8 9.24996 20.7C9.45 20.7999 9.65004 20.7 9.69996 20.4999C9.75 20.45 9.75 20.4 9.75 20.3V19.5999C9.75 19.4499 9.6 19.25 9.45 19.1499ZM14.75 3.54992C14.55 3.44996 14.35 3.54992 14.3 3.74996C14.25 3.8 14.25 3.84992 14.25 3.95V4.64996C14.25 4.85 14.4 5.04992 14.55 5.15C18.45 6.54992 20.45 10.8999 19 14.75C18.25 16.85 16.6 18.45 14.55 19.2C14.35 19.2999 14.25 19.4499 14.25 19.7V20.4C14.25 20.6 14.35 20.75 14.55 20.7999C14.6 20.7999 14.7 20.7999 14.75 20.75C19.5 19.25 22.1 14.1999 20.6 9.44996C19.7 6.59996 17.5 4.44992 14.75 3.54992Z'
      fill='white'
    />
  </svg>
))

const DEPOSIT_CURRENCY_ICONS: Record<'BTC' | 'ETH' | 'USDC' | 'USDT', IconFCType> = {
  BTC: BitcoinCurrencyIcon,
  ETH: EthereumCurrencyIcon,
  USDC: UsdCoinCurrencyIcon,
  USDT: TetherCurrencyIcon,
}

const DEPOSIT_VALUE_TO_ICON_CODE: Record<string, keyof typeof DEPOSIT_CURRENCY_ICONS> = {
  BTC: 'BTC',
  ETH: 'ETH',
  USDC: 'USDC',
  USDT: 'USDT',
  // BE values for chain-specific options from crypto selector (Channel A/B/C variants)
  ERC20: 'USDT',
  TRC20: 'USDT',
  USDT_BSC: 'USDT',
  USDT_ERC20: 'USDT',
  USDT_TRC20: 'USDT',
  USDTERC20: 'USDT',
  USDTTRC20: 'USDT',
  USDCERC20: 'USDC',
  USDC_ERC20: 'USDC',
}

export const getFundingCurrencyIcon = (currencyValue?: string): IconFCType | undefined => {
  if (!currencyValue) {
    return undefined
  }

  const normalizedValue = currencyValue.toUpperCase().trim()
  const iconCode = DEPOSIT_VALUE_TO_ICON_CODE[normalizedValue]

  if (!iconCode) {
    return undefined
  }

  return DEPOSIT_CURRENCY_ICONS[iconCode]
}
